export default __webpack_public_path__ + "static/media/referencesIcon.f7677802.svg";